// Locale-aware number and currency formatting
//
// EN: "$1,000.50"  —  $ prefix, comma thousands, period decimal
// FR: "1 000,50 $" —  $ suffix, space thousands, comma decimal (Quebec standard)
//
// Uses Intl.NumberFormat under the hood (fr-CA naturally uses NBSP thousands and comma decimals).

const toLocale = (lang) => (lang === 'fr' ? 'fr-CA' : 'en-US');

const toNum = (value) => {
  if (typeof value === 'number') return value;
  const n = parseFloat(value);
  return isNaN(n) ? 0 : n;
};

// Money with 2 decimals, locale-aware placement of $ and separators.
export const formatMoney = (value, lang = 'en') => {
  const n = toNum(value);
  const digits = n.toLocaleString(toLocale(lang), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return lang === 'fr' ? `${digits} $` : `$${digits}`;
};

// Integer or decimal number with locale-aware thousands separators. No currency.
export const formatNumber = (value, lang = 'en', decimals = 0) => {
  const n = toNum(value);
  return n.toLocaleString(toLocale(lang), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
